import { render, staticRenderFns } from "./MyAchievement.vue?vue&type=template&id=54563d43&"
import script from "./MyAchievement.vue?vue&type=script&lang=js&"
export * from "./MyAchievement.vue?vue&type=script&lang=js&"
import style0 from "./MyAchievement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports